import Image from 'library/components/image';
import { TYPE } from 'store/browse-items/fixtures';
import Color from 'library/components/color';
import { useMemo } from 'react';
import {
  Content,
  Text,
  ItemContainer,
  Item,
  LeftContainer,
  ImageContainer,
  ItemText,
  DeleteItemIconContainer,
  DeleteItemIcon,
} from './styles';
import withModalContainer from './hocs/with-modal-container';
import Colors from '../../constants/colors';

const SetImage = (color) => (
  <svg fill={color} width="30" height="25" viewBox="0 0 90 75" xmlns="http://www.w3.org/2000/svg">
    <path fill={color} fillRule="evenodd" clipRule="evenodd" d="M10 5H36.8436C39.0896 5 41.06 6.49768 41.6612 8.66178L43.4218 15H5V10C5 7.23858 7.23858 5 10 5ZM0 15V10C0 4.47715 4.47715 0 10 0H36.8436C41.3357 0 45.2765 2.99536 46.4788 7.32356L48.6111 15H80C85.5229 15 90 19.4772 90 25V65C90 70.5229 85.5229 75 80 75H10C4.47715 75 0 70.5229 0 65V20V15ZM5 20V65C5 67.7614 7.23858 70 10 70H80C82.7614 70 85 67.7614 85 65V25C85 22.2386 82.7614 20 80 20H50H5Z" />
  </svg>
);

function add3Dots(string, limit) {
  const dots = '...';
  if (string.length > limit) {
    // eslint-disable-next-line no-param-reassign
    string = string.substring(0, limit) + dots;
  }
  return string;
}

const Confirm = ({
  text, data = [], onDeselect, type,
}) => {
  const renderItem = ({ id, ...restProps }) => {
    const getEntity = () => {
      if (type === TYPE.IMAGE) {
        const [image] = restProps.images || [{ url: '' }];
        return (
          <LeftContainer key={`${id}-${type}`}>
            <Image
              id={id}
              source={image}
              width={40}
              isCover
            />
          </LeftContainer>
        );
      }

      if (type === TYPE.COLOR) {
        return (
          <LeftContainer key={`${id}-${type}`}>
            <Color id={id} color={`${restProps?.value.includes('#') ? '' : '#'}${restProps.value}`} width={40} />
          </LeftContainer>
        );
      }

      if (type === TYPE.SET) {
        const normalizedColor = restProps.color || Colors.violet;
        const image = useMemo(() => SetImage(normalizedColor.includes('#') ? normalizedColor : `#${normalizedColor}`), []);

        return (
          <LeftContainer key={`${id}-${type}`}>
            {image}
            <ItemText>{add3Dots(restProps.name, 29)}</ItemText>
          </LeftContainer>
        );
      }

      const [image] = restProps.images || [{ url: '' }];

      return (
        <LeftContainer key={`${id}-${type}`}>
          <ImageContainer>
            <Image isCover name={restProps.name} id={id} source={image} width={40} />
          </ImageContainer>
          <ItemText>{add3Dots(restProps.name, 29)}</ItemText>
        </LeftContainer>
      );
    };

    return (
      <Item key={`${id}-${type}`}>
        {getEntity()}
        <DeleteItemIconContainer>
          <DeleteItemIcon className="icon-trash" onClick={() => onDeselect(id)} />
        </DeleteItemIconContainer>
      </Item>
    );
  };

  return (
    <Content>
      <Text>{text}</Text>
      <ItemContainer>
        {data.map(renderItem)}
      </ItemContainer>
    </Content>
  );
};

export default withModalContainer(Confirm);
